import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewOptions: {
		id: 'navigation-kit-tab-menu.view-options',
		defaultMessage: 'Tab options',
		description: 'Label of the button to open the pop up menu with the tab options.',
	},
});
